import { gql } from '@apollo/client'
import { DXO_EXECUTION } from '../fragments/DXOExecution'

export const GET_DXO_EXECUTION_BY_STORE_CHAIN = gql`
  query GetDXOExecutionByStoreChain($input: DXOExecutionInput!) {
    dxoExecutionByStoreChain(input: $input) {
      results {
        ...DXOExecution
      }
      count
      hasMore
    }
  }
  ${DXO_EXECUTION}
`
